import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import GuardianCard from './_guardians_card';

import { guardians } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(4),
    // background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
}));

const Guardians = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        container
      >
        <Grid
          item
          xs={12}
        >
          <Paper className={classes.paper}>
            <Typography
              align="center"
              component="h2"
              variant="h1"
            >
              Incarnez un des trois gardiens
            </Typography>
            <Typography
              align="center"
              component="p"
              variant="body2"
            >
              Choisissez le gardien qui vous convient et partez à l'aventure !
            </Typography>
          </Paper>
        </Grid>

        {guardians.map((guardian, index) => {
          return (
            <Grid
              component="article"
              item
              key={`guardian-${index}`}
              md={4}
              sm={12}
              xs={12}
            >
              <GuardianCard guardian={guardian} />
            </Grid>
          )
        })}

      </Grid>
    </>
  );
}

export default Guardians;
